import { Component, Input } from '@angular/core';
import { bodyComponent } from "./components/body.component";
import { MenuComponent } from './menu/menu.component';
import { httpService } from './service/servicio';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { DatosmaquinasComponent } from './datosmaquinas/datosmaquinas.component';
import { DatosposicionesComponent } from './datosposiciones/datosposiciones.component';
import { ClientesComponent } from './clientes/clientes.component';
import { ArticulosComponent } from './articulos/articulos.component';
import { DatosarticulosComponent } from './datosarticulos/datosarticulos.component';
import { TarifasComponent } from './tarifas/tarifas.component';
import { MarcasComponent } from './marcas/marcas.component';
import { ModelosComponent } from './modelos/modelos.component';
import { RecaudacionesComponent } from './recaudaciones/recaudaciones.component';
import { CargasComponent } from './cargas/cargas.component';
import { VisitasComponent } from './visitas/visitas.component';
import { FacturasComponent } from './facturas/facturas.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],

})

export class AppComponent {

  constructor (public http:httpService, public toastr: ToastsManager, public vcr: ViewContainerRef) {

        this.toastr.setRootViewContainerRef(vcr);
        this.cargarUsuario();

      }

      a1:number = 1;
      icon1:string = "fa fa-microchip";
      tituloMenu:string = 'Vending Fernando Durán - Módulo Máquinas';

      @Input() usuario:any = {

         Id: 0,
         User: '',
         Pass: '',
         Otro: 0

      };

      cargarUsuario() {

          let logged = localStorage.getItem("logged");

          if (logged =='1') {
            this.usuario = JSON.parse(localStorage.getItem("usuario"));
          }else{

           this.usuario.Id = 0;
           this.usuario.User ='';
           this.usuario.Pass = '';
           this.usuario.Otro = '';

         }



         if (this.usuario.Id > 0) {

            this.login();

         }else{

           this.toastr.warning('Debes Loguearte para acceder','Login');
           this.http.sw.mostrarLogin = true;

         }

      }

      login() {
        this.http.loading = true;
         ("en login");
        this.http.hacer_login(this.usuario.User, this.usuario.Pass)
        .subscribe(usuario => {
           (usuario);
          this.usuario = usuario;
        }, err => {
          this.usuario.Id = 0;
           (err.message);
        }, () => {

           ('completed');

          if (this.usuario.Id > 0) {

              this.toastr.success('Login Correcto. Bienvenido: ' + this.usuario.User,'Login');

              localStorage.setItem("logged", "1");
              localStorage.setItem("usuario", JSON.stringify(this.usuario));

              this.http.user = this.usuario.User;
              this.http.pass = this.usuario.Pass;

              if (this.usuario.Otro == 0) {
                this.http.sw.mostrarLogin = false;
                this.http.sw.mostrarMenu = true;
                this.http.sw.mostrarMaquinas = true;
                this.http.modoOperador = false;
              } else {
                this.http.sw.mostrarLogin = false;
                this.http.sw.mostrarMenu = false;
                this.http.sw.mostrarCargasOperador = true;
                this.http.modoOperador = true;
              }

          }else {

              this.toastr.error("Debes Loguearte",'Login');
              this.http.sw.mostrarLogin = true;
              this.http.sw.mostrarMenu = false;
              this.http.sw.mostrarMaquinas = false;

          }

        });
      }

      Logout(){
        this.activarMaquinas()
        this.http.sw.mostrarLogin = true;
        this.http.sw.mostrarMenu = false;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarCargasOperador = false;

        this.usuario.Id = 0;
        this.usuario.User = '';
        this.usuario.Pass = 0;
        localStorage.setItem("logged", "0");
        localStorage.setItem("usuario", JSON.stringify(this.usuario));


      }

      showtoast() {
        this.toastr.success('Login Correcto. Bienvenido: ' + this.usuario.User,'Login');
      }



      activarPosiciones(){
        this.http.sw.mostrarFacturas = false;
        this.http.sw.mostrarVisitas = false;
        this.http.sw.mostrarPosiciones= true;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarTarifas = false;
        this.http.sw.mostrarMarcas = false;
        this.http.sw.mostrarArticulos = false;
        this.http.sw.mostrarModelos = false;
        this.http.sw.mostrarRecaudaciones = false;
        this.http.sw.mostrarCargas = false;
        this.http.sw.mostrarLotes = false;
        this.a1=2;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Posiciones';
      }

      activarMaquinas(){
        this.http.sw.mostrarFacturas = false;
        this.http.sw.mostrarVisitas = false;
        this.http.sw.mostrarArticulos = false;
        this.http.sw.mostrarPosiciones= false;
        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarMaquinas = true;
        this.http.sw.mostrarTarifas = false;
        this.http.sw.mostrarMarcas = false;
        this.http.sw.mostrarModelos = false;
        this.http.sw.mostrarRecaudaciones = false;
        this.http.sw.mostrarCargas = false;
        this.http.sw.mostrarLotes = false;
        this.http.sw.mostrarCargasOperador = false;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Máquinas';
        this.a1=1;
      }

      activarVisitas(){
        this.http.sw.mostrarFacturas = false;
        this.http.sw.mostrarVisitas = true;
        this.http.sw.mostrarArticulos = false;
        this.http.sw.mostrarPosiciones= false;
        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarTarifas = false;
        this.http.sw.mostrarMarcas = false;
        this.http.sw.mostrarModelos = false;
        this.http.sw.mostrarRecaudaciones = false;
        this.http.sw.mostrarCargas = false;
        this.http.sw.mostrarLotes = false;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Visitas - Rutas';
        this.a1=1;
      }


      activarClientes(){
        this.http.sw.mostrarFacturas = false;
        this.http.sw.mostrarVisitas = false;
        this.http.sw.mostrarArticulos = false;
        this.http.sw.mostrarPosiciones= false;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarClientes = true;
        this.http.sw.mostrarTarifas = false;
        this.http.sw.mostrarMarcas = false;
        this.http.sw.mostrarModelos = false;
        this.http.sw.mostrarRecaudaciones = false;
        this.http.sw.mostrarCargas = false;
        this.http.sw.mostrarLotes = false;
        this.a1=3;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Clientes';

      }

      activarArticulos(){
        this.http.sw.mostrarFacturas = false;
        this.http.sw.mostrarVisitas = false;
        this.http.sw.mostrarTarifas = false;
        this.http.sw.mostrarPosiciones= false;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarArticulos = true;
        this.http.sw.mostrarMarcas = false;
        this.http.sw.mostrarModelos = false;
        this.http.sw.mostrarRecaudaciones = false;
        this.http.sw.mostrarCargas = false;
        this.http.sw.mostrarLotes = false;
        this.a1=4;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Artículos';

      }

      activarTarifas(){
        this.http.sw.mostrarFacturas = false;
        this.http.sw.mostrarVisitas = false;
        this.http.sw.mostrarPosiciones= false;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarArticulos = false;
        this.http.sw.mostrarTarifas = true;
        this.http.sw.mostrarMarcas = false;
        this.http.sw.mostrarModelos = false;
        this.http.sw.mostrarRecaudaciones = false;
        this.http.sw.mostrarCargas = false;
        this.http.sw.mostrarLotes = false;
        this.a1=4;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Artículos';

      }

      activarMarcas(){
        this.http.sw.mostrarFacturas = false;
        this.http.sw.mostrarVisitas = false;
        this.http.sw.mostrarPosiciones= false;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarArticulos = false;
        this.http.sw.mostrarTarifas = false;
        this.http.sw.mostrarMarcas = true;
        this.http.sw.mostrarModelos = false;
        this.http.sw.mostrarRecaudaciones = false;
        this.http.sw.mostrarCargas = false;
        this.http.sw.mostrarLotes = false;
        this.a1=5;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Marcas';

      }

      activarModelos(){
        this.http.sw.mostrarFacturas = false;
        this.http.sw.mostrarVisitas = false;
        this.http.sw.mostrarPosiciones= false;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarArticulos = false;
        this.http.sw.mostrarTarifas = false;
        this.http.sw.mostrarMarcas = false;
        this.http.sw.mostrarRecaudaciones = false;
        this.http.sw.mostrarModelos = true;
        this.http.sw.mostrarCargas = false;
        this.http.sw.mostrarLotes = false;
        this.a1=6;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Modelos';

      }

      activarRecaudaciones(){
        this.http.sw.mostrarFacturas = false;
        this.http.sw.mostrarVisitas = false;
        this.http.sw.mostrarPosiciones= false;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarArticulos = false;
        this.http.sw.mostrarTarifas = false;
        this.http.sw.mostrarMarcas = false;
        this.http.sw.mostrarModelos = false;
        this.http.sw.mostrarRecaudaciones = true;
        this.http.sw.mostrarCargas = false;
        this.http.sw.mostrarLotes = false;
        this.a1=7;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Recaudaciones';

      }

      activarCargas(){
        this.http.sw.mostrarFacturas = false;
        this.http.sw.mostrarVisitas = false;
        this.http.sw.mostrarPosiciones= false;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarArticulos = false;
        this.http.sw.mostrarTarifas = false;
        this.http.sw.mostrarMarcas = false;
        this.http.sw.mostrarModelos = false;
        this.http.sw.mostrarRecaudaciones = false;
        this.http.sw.mostrarCargas = true;
        this.http.sw.mostrarLotes = false;
        this.a1=7;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Cargas';

      }

      activarFacturas(){
        this.http.sw.mostrarVisitas = false;
        this.http.sw.mostrarPosiciones= false;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarArticulos = false;
        this.http.sw.mostrarTarifas = false;
        this.http.sw.mostrarMarcas = false;
        this.http.sw.mostrarModelos = false;
        this.http.sw.mostrarRecaudaciones = false;
        this.http.sw.mostrarCargas = false;
        this.http.sw.mostrarFacturas = true;
        this.http.sw.mostrarLotes = false;
        this.a1=8;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Facturas';

      }

      activarLotes(){
        this.http.sw.mostrarVisitas = false;
        this.http.sw.mostrarPosiciones= false;
        this.http.sw.mostrarMaquinas = false;
        this.http.sw.mostrarClientes = false;
        this.http.sw.mostrarArticulos = false;
        this.http.sw.mostrarTarifas = false;
        this.http.sw.mostrarMarcas = false;
        this.http.sw.mostrarModelos = false;
        this.http.sw.mostrarRecaudaciones = false;
        this.http.sw.mostrarCargas = false;
        this.http.sw.mostrarFacturas = false;
        this.http.sw.mostrarLotes = true;

        this.a1=9;
        this.tituloMenu = 'Vending Fernando Durán - Módulo Lotes';

      }

}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/app.component.ts